<template>

<app-table empty-message="There are no additional items attached." :empty="!items.length">

	<app-table-head :layout="layout">

		<app-table-column text="Name" />
		
		<app-table-column text="Sale" />
		
		<app-table-column text="Check-in" />

	</app-table-head>

	<app-table-body>

		<app-table-row :layout="layout" v-for="item in items" :key="item.id">

			<app-table-cell-text :text="item.name" />
			
			<app-table-cell-item type="convention/registration/sale" :item="item.sale" />
			
			<app-table-cell-label v-if="item.received" :text="$constants.badge.collectedName[1]" :type="$constants.badge.collectedTheme[1]" :subtext="item.received | localDate('MM/DD/YYYY h:mma')" />
			
			<app-table-cell-label v-if="!item.received" :text="$constants.badge.collectedName[0]" :type="$constants.badge.collectedTheme[0]" />

		</app-table-row>

	</app-table-body>

</app-table>

</template>

<script>

export default {

	props: ['items'],

	data: function() {
	
		return {
			layout: 'auto 240px 240px'
		}
	
	}

}

</script>

<style scoped>

</style>